import { motion } from "motion/react";
import sriLankaImage from "../assets/itinerary-format-2.webp";
// Bundled, not a video.stippl.io link: renders there belong to a workspace's Movies page and get deleted with it.
import reelVideoLandscape from "../../../../img/video/b2b-trip-landscape.mp4";

const features = [
	{
		id: "client",
		title: (
			<span>
				See it the way <br className="md:hidden" /> your client would.
			</span>
		),
		alt: "See it the way your client would",
		description: "Interactive, branded, beautiful, this is what lands in their inbox instead of a Word doc.",
	},
	{
		id: "reel",
		title: "Travel reels that inspire",
		alt: "Travel reels that inspire",
		description: "Transform your itineraries into stunning video reels perfect for social media and client presentations.",
	},
	{
		id: "map",
		title: "Embedded maps for context",
		alt: "Embedded maps for context",
		description: "Give your clients a visual overview with embedded interactive maps showing all destinations.",
	},
	{
		id: "pdf",
		title: "Share itineraries with anyone!",
		alt: "Share itineraries with anyone!",
		description: "You can do it all with Stippl: embed in your site, share a public link or download as PDF.",
	},
];

export function ItineraryFormats() {
	return (
		<section className="relative py-24 px-6" style={{ backgroundColor: "#FAFBFC" }}>
			<div className="relative max-w-7xl mx-auto">
				{/* Header */}
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={{ duration: 0.6 }}
					className="text-center mb-16"
				>
					<p className="text-sm font-semibold tracking-wide mb-3 uppercase" style={{ color: "#8B5CF6" }}>
						CREATE ONCE
					</p>
					<h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight" style={{ color: "#0F3E4A", fontFamily: "Poppins, sans-serif" }}>
						Effortless to build.
						<br />
						Impossible to ignore.
					</h2>
					<p className="text-base md:text-lg max-w-4xl mx-auto leading-relaxed" style={{ color: "#6B7280" }}>
						Proposals, maps, reels and PDFs, all from one trip. All beautiful. All ready to send.
					</p>
				</motion.div>

				<div className="max-w-7xl mx-auto">
					{/* Row 1: Full Demo (2 cols) + Share Itineraries (1 col) */}
					<div className="grid md:grid-cols-3 gap-8 mb-8">
						{/* HERO CARD - Full Demo */}
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.6 }}
							whileHover={{ y: -8, transition: { duration: 0.3 } }}
							className="md:col-span-2 bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer relative border border-gray-100 flex flex-col  md:h-[600px]"
						>
							<div className="absolute top-6 right-6 z-10">
								<div
									className="px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide backdrop-blur-sm"
									style={{
										background: "rgba(139, 92, 246, 0.9)",
										color: "white",
										boxShadow: "0 4px 12px rgba(139, 92, 246, 0.3)",
									}}
								>
									Full Demo
								</div>
							</div>

							<div className="p-8 md:p-10 pb-0">
								<h3 className="text-2xl md:text-3xl font-bold mb-3 leading-tight" style={{ color: "#0F3E4A", fontFamily: "Poppins, sans-serif" }}>
									{features[0].title}
								</h3>
								<p className="text-base leading-relaxed" style={{ color: "#6B7280" }}>
									{features[0].description}
								</p>
							</div>

							<div className="relative overflow-hidden flex-1 min-h-[250px] md:min-h-[380px]">
								<iframe
									src="https://app.arcade.software/share/Ham9fN91Ro1apx65YPNT"
									title="See it the way your client would"
									className="absolute top-0 left-0 w-full h-full"
									frameBorder="0"
									loading="lazy"
									allowFullScreen
									allow="clipboard-write"
								/>
							</div>
						</motion.div>

						{/* Share Itineraries Card */}
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.6, delay: 0.1 }}
							whileHover={{ y: -8, transition: { duration: 0.3 } }}
							className="bg-white rounded-3xl flex flex-col overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer border border-gray-100 h-[400px] md:h-[600px]"
						>
							<div className="p-8 md:p-10 pb-6">
								<h3 className="text-2xl md:text-3xl font-bold mb-3 leading-tight" style={{ color: "#0F3E4A", fontFamily: "Poppins, sans-serif" }}>
									{features[3].title}
								</h3>
								<p className="text-base leading-relaxed" style={{ color: "#6B7280" }}>
									{features[3].description}
								</p>
							</div>
							<div className="flex-1 overflow-hidden flex items-center justify-center px-4 pt-2 pb-0">
								<img
									src={sriLankaImage}
									alt={features[3].alt}
									style={{
										width: "100%",
										height: "100%",
										objectFit: "contain",
										objectPosition: "top center",
										clipPath: "inset(0 0 6px 0)",
									}}
								/>
							</div>
						</motion.div>
					</div>

					{/* Row 2: Video Reel + Embedded Map */}
					<div className="grid md:grid-cols-2 gap-8">
						{/* Video Reel Card */}
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.6, delay: 0.2 }}
							whileHover={{ y: -8, transition: { duration: 0.3 } }}
							className="bg-white rounded-3xl flex flex-col overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer border border-gray-100"
						>
							<div className="p-8 md:p-10 pb-6">
								<h3 className="text-2xl md:text-3xl font-bold mb-3 leading-tight" style={{ color: "#0F3E4A", fontFamily: "Poppins, sans-serif" }}>
									{features[1].title}
								</h3>
								<p className="text-base leading-relaxed" style={{ color: "#6B7280" }}>
									{features[1].description}
								</p>
							</div>
							<div className="mt-auto w-full overflow-hidden" style={{ height: "400px" }}>
								<video
									src={reelVideoLandscape}
									className="w-full h-full object-cover"
									autoPlay
									loop
									muted
									playsInline
								/>
							</div>
						</motion.div>

						{/* Embedded Map Card */}
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.6, delay: 0.3 }}
							whileHover={{ y: -8, transition: { duration: 0.3 } }}
							className="bg-white rounded-3xl flex flex-col overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer border border-gray-100"
						>
							<div className="p-8 md:p-10 pb-5">
								<h3 className="text-2xl md:text-3xl font-bold mb-3 leading-tight" style={{ color: "#0F3E4A", fontFamily: "Poppins, sans-serif" }}>
									{features[2].title}
								</h3>
								<p className="text-base leading-relaxed" style={{ color: "#6B7280" }}>
									{features[2].description}
								</p>
							</div>
							<div className="flex-1" style={{ minHeight: "340px" }}>
								<iframe
									src="https://embed.stippl.io/6992e179304b39f2360f3004"
									style={{ border: "none", display: "block", width: "100%", height: "100%", minHeight: "340px" }}
									loading="lazy"
									title="Stippl Embedded Map"
								/>
							</div>
						</motion.div>
					</div>
				</div>
			</div>
		</section>
	);
}
